import { LitElement, html } from 'lit'
import { navigate } from '../router.js'

class PageNotFound extends LitElement {
  render() {
    return html`
      <div style="text-align:center;padding:4rem 1rem">
        <h1>404 — Page Not Found</h1>
        <p>The page you're looking for doesn't exist.</p>
        <button @click=${() => navigate('/')}>Go Home</button>
      </div>
    `
  }
}

customElements.define('page-not-found', PageNotFound)
